module.exports = __webpack_public_path__ + "img/1F1F8-1F1F9.f4e2b61d.svg";